module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko/assessment_achievements/3@2x_9b142e150446f78bd26d4ab0ffb78632.png";